import * as moment from 'moment';

type JSONMetric = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dimensions: Maybe<any>;
  timestamp: string;
  sum: string;
  unit: string;
};

type Metric = {
  timestamp: moment.Moment;
  sum: number;
  unit: string;
};

function fromJSON(jsonMetric: JSONMetric): Metric {
  return {
    timestamp: moment(jsonMetric.timestamp),
    sum: Number(jsonMetric.sum),
    unit: jsonMetric.unit,
  };
}

export default Metric;
export { fromJSON, JSONMetric };
